<script>
    // "Свой тип" (869fcmxu1): a searchable pick of the asset type for rows
    // where neither the folder nor the model was right, plus its Apply.
    export default {
        props: {
            types: { type: Array, required: true }, // [{ id, name }]
            disabled: Boolean,
        },
        emits: ['apply'],
        data() {
            return { query: '', picked: null, open: false };
        },
        computed: {
            options() {
                // A picked name in the box is not a search: show everything.
                const q = this.picked ? '' : this.query.trim().toLowerCase();
                return this.types.filter((t) => t.name.toLowerCase().includes(q));
            },
        },
        beforeUnmount() { document.removeEventListener('click', this.onOutside); },
        methods: {
            show(e) {
                e?.target?.select?.();
                if (this.open) return;
                this.open = true;
                setTimeout(() => document.addEventListener('click', this.onOutside));
            },
            hide() {
                this.open = false;
                document.removeEventListener('click', this.onOutside);
            },
            onOutside(e) { if (!this.$el.contains(e.target)) this.hide(); },
            onInput() { this.picked = null; this.show(); },
            pick(t) { this.picked = t; this.query = t.name; this.hide(); },
            apply() {
                if (this.picked == null || this.disabled) return;
                this.$emit('apply', this.picked);
            },
            reset() { this.picked = null; this.query = ''; },
        },
    };
</script>

<template>
    <div class="own">
        <input
            v-model="query"
            class="own_input"
            placeholder="Свой тип…"
            aria-label="Свой тип: начните печатать название"
            title="Если неправы и папка, и модель: выберите тип сами."
            @focus="show"
            @click="show"
            @input="onInput"
            @keydown.enter.prevent="options.length === 1 ? pick(options[0]) : apply()"
            @keydown.esc="hide"
        >
        <button class="button_blue_150 own_apply" :disabled="picked == null || disabled" @click="apply">Применить</button>
        <div v-if="open" class="own_list">
            <button
                v-for="t in options" :key="t.id"
                type="button"
                class="own_item"
                :class="{ on: picked && picked.id === t.id }"
                @click="pick(t)"
            >{{ t.name }}</button>
            <div v-if="options.length === 0" class="own_empty">Нет такого типа</div>
        </div>
    </div>
</template>

<style scoped>
    .own { position: relative; display: flex; align-items: center; }
    .own_input {
        height: 36px; width: 180px; box-sizing: border-box;
        border: 2px solid var(--main-color); border-right: 0;
        border-radius: 5px 0 0 5px; padding: 0 10px;
        font: inherit; font-size: 13px;
        background: var(--background-color); color: var(--text-color);
    }
    .own_apply { height: 36px; width: auto; padding: 0 16px; border-radius: 0 5px 5px 0; }
    .own_apply:disabled { opacity: 0.45; }
    .own_list {
        position: absolute; top: 40px; left: 0; z-index: 60;
        width: 180px; padding: 4px;
        background: var(--background-color); color: var(--text-color);
        border: 1px solid var(--border-color); border-radius: 5px;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    }
    .own_item {
        display: block; width: 100%; padding: 8px 10px;
        border: 0; border-radius: 4px; background: transparent;
        text-align: left; font: inherit; font-size: 13px; color: inherit; cursor: pointer;
    }
    .own_item:hover, .own_item.on { background: var(--background-hover); }
    .own_empty { padding: 8px 10px; font-size: 12px; color: var(--text-color-secondary); }
</style>
